(function($) {
    $(function() {
        var jcarousel = $('.jcarousel_ourteam');

        jcarousel
            .on('jcarousel:reload jcarousel:create', function () {
                var width = jcarousel.innerWidth();

                 if (width >= 621) {
					 width = width / 3;
					  $('.jcarousel-wrapper_ourteam .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-wrapper_ourteam .jcarousel-control-next')
            .jcarouselControl({
                target: '+=1'
            }); 
		
				 }
                else if (width >= 600) {
                    width = width / 1;
					  $('.jcarousel-wrapper_ourteam .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-wrapper_ourteam .jcarousel-control-next')
            .jcarouselControl({
                target: '+=1'
            });
			 $('.jcarousel-wrapper_ourteam .jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .on('click', function(e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function(page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                }
            });
                } else if (width >= 350) {
                    width = width / 1;
					  $('.jcarousel-wrapper_ourteam .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-wrapper_ourteam .jcarousel-control-next')
            .jcarouselControl({
                target: '+=1'
            });
                }

                jcarousel.jcarousel('items').css('width', width + 'px');
            })
            .jcarousel({
                wrap: 'circular'
            });

        $('.jcarousel-wrapper_ourteam .jcarousel-control-prev')
            .jcarouselControl({
                target: '-=1'
            });

        $('.jcarousel-wrapper_ourteam .jcarousel-control-next')
            .jcarouselControl({
                target: '+=1'
            });
			
	    $('jcarousel_ourteam').jcarouselAutoscroll({
    target: '+=1'
});
$('jcarousel_ourteam').jcarouselAutoscroll('reload', {
    interval: 4500
});


jcarousel.touchwipe({
  wipeLeft: function() {
    jcarousel.jcarousel('scroll', '+=1');
  },
  wipeRight: function() {
    jcarousel.jcarousel('scroll', '-=1');
  },
  min_move_x: 20,
  min_move_y: 20,
  preventDefaultEvents: false
});

        
		 $('.jcarousel_ourteam').hover(function() {
			$('.jcarousel_ourteam').jcarouselAutoscroll('stop'); 
		 }, function() {
			 $('.jcarousel_ourteam').jcarouselAutoscroll('start');
		 });


        $('.jcarousel-wrapper_ourteam .jcarousel-pagination')
            .on('jcarouselpagination:active', 'a', function() {
                $(this).addClass('active');
            })
            .on('jcarouselpagination:inactive', 'a', function() {
                $(this).removeClass('active');
            })
            .on('click', function(e) {
                e.preventDefault();
            })
            .jcarouselPagination({
                perPage: 1,
                item: function(page) {
                    return '<a href="#' + page + '">' + page + '</a>';
                }
            });
    });
})(jQuery);
